// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"A5-z","displaySixCardTiles":"B5-z"};